// @flow
import React from 'react';
import titlesMessages from '../../../common/app/messages/titles';
import Title from '../../components/Title';
import Box from '../../../common/components/Box';
import TopBar from '../TopBar';
import MessageBox from './MessageBox';
import AdminNotification from '../AdminNotification';

class PriceListPage extends React.PureComponent {
  render() {
    return (
      <Box flex={1} height="100%" backgroundColor="appBg">
        <Title message={titlesMessages.admin} />

        <TopBar />

        <Box zIndex={1} id="kitchenMessage" flex={1} height="calc(100% - 36px)">
          <MessageBox />

          <AdminNotification hideNotificationOnUnmount={false} />
        </Box>
      </Box>
    );
  }
}

export default PriceListPage;
